import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { SetAccess } from '../state-management';

@Injectable({
  providedIn: 'root',
})
export class RequestInterceptor implements HttpInterceptor {

  constructor(
    private readonly router: Router, private store: Store<{}>
  ) {
  }

  /**
   * @param HttpRequest<any> request - The intercepted request
   * @param HttpHandler next - The next interceptor in the pipeline
   * @return Observable<HttpEvent<any>>
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // request = this.addToken(request);
    return next.handle(request)
      // add error handling
      .pipe(
        catchError(
          (error: any, caught: Observable<HttpEvent<any>>) => {
            if (error.status === 403) {
              this.handleAuthError();
              // if you've caught / handled the error, you don't
              // want to rethrow it unless you also want
              // downstream consumers to have to handle it as
              // well.
              return of(error);
            }
            throw error;
          }
        ),
      );
  }

  /**
   * Handle API authentication errors.
   */
  private handleAuthError() {
    this.store.dispatch(new SetAccess(false));
    this.router.navigate(['/unauthorized']);
  }

  // /**
  //  * Add stored auth token to request headers.
  //  * @param HttpRequest<any> request - the intercepted request
  //  * @return HttpRequest<any> - the modified request
  //  */
  // private addToken(request: HttpRequest<any>): HttpRequest<any> {
  //   const token: string = sessionStorage.getItem('access_token');
  //   if (token) {
  //     return request.clone({
  //       setHeaders: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //   }
  //   return request;
  // }

}
